<template>
	<div class="item-card" @click="onOpen">
		<div class="left">
			<div class="icon" aria-hidden="true">
				<Icon :name="iconName" size="lg" class="item-icon"/>
				<div v-if="status" :class="['status-dot', status]" :title="`Status: ${status}`"></div>
			</div>
			<div class="text">
				<div class="title">{{ title }}</div>
<!--				<div v-if="subtitle" class="subtitle">{{ subtitle }}</div>-->
			</div>
		</div>
		<div class="right" @click.stop>
			<div v-if="subtitle && subtitle.length" class="subtitle">
				<div v-for="(item, index) in subtitle" :key="index" class="subtitle-line">
					<Icon :name="item.icon" size="xs" class="subtitle-icon"/>
					<span class="subtitle-text">{{ item.value }}</span>
				</div>
			</div>
<!--			<div v-if="meta" class="meta">{{ meta }}</div>-->
<!--			<label v-if="selectable" class="select">-->
<!--				<input type="checkbox" :checked="modelValue"-->
<!--					   @change="$emit('update:modelValue', $event.target.checked)"/>-->
<!--			</label>-->
		</div>
	</div>
</template>

<script setup>
import Icon from "./Icon.vue";

const props = defineProps({
	title: {type: String, required: true},
	subtitle: {type: Object, default: ''},
	meta: {type: String, default: ''},
	selectable: {type: Boolean, default: false},
	modelValue: {type: Boolean, default: false},
	iconName: {type: String, default: 'tv'},
	status: {type: String, default: ''}
})

const emit = defineEmits(['open', 'update:modelValue', 'action'])

function onOpen() {
	emit('open')
}
</script>

<style scoped>
.item-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background: var(--color-popup-2);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-xl);
	padding: var(--spacing-lg);
	transition: background 150ms ease, border-color 150ms ease;
}

.left {
	display: flex;
	gap: var(--spacing-md, 12px);
	align-items: center;
}

.icon {
	position: relative;
	display: grid;
	margin-right: var(--spacing-xs);
	place-items: center;
}

.status-dot {
	position: absolute;
	top: 0;
	right: 0.1rem;
	width: 0.9rem;
	height: 0.9rem;
	border-radius: 50%;
	border: 0.2rem solid var(--color-surface);
	transition: all var(--transition-fast);
}

.status-dot.online {
	background-color: var(--color-success);
	/*box-shadow: 0 0 0 0.1rem var(--color-success);*/
}

.status-dot.offline {
	background-color: var(--color-error);
	/*box-shadow: 0 0 0 0.1rem var(--color-error);*/
}

.text {
	display: flex;
	flex-direction: column;
}

.title {
	font-size: var(--font-size-base);
	font-weight: var(--font-weight-bold);
	color: var(--color-text, #fff);
	line-height: 1.2;
	text-align: start;
}

.subtitle {
	display: grid;
	gap: 0.3rem;
	text-align: start;
	font-size: var(--font-size-xs);
	color: var(--color-subtle, #9aa0a6);
	margin-top: var(--spacing-xs);
	margin-left: var(--spacing-sm);
	white-space: pre-line;
}

.subtitle-line {
	display: flex;
	gap: 0.3rem;
}

.right {
	display: flex;
	align-items: center;
	gap: 1rem;
}

.meta {
	font-size: 12px;
	color: var(--color-subtle, #9aa0a6);
}

.select input {
	width: 18px;
	height: 18px;
}

.action-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 8px 10px;
	background: var(--color-primary, #2d7ff9);
	color: #fff;
	border: none;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
}

.action-btn:active {
	transform: translateY(1px);
}
</style>